import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deactivateOrgStructureAssignment as apiFn } from "../../api/apiOrgStructureAssignments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeactivateOrgStructureAssignment() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: deactivateAssignment, isPending: isDeactivating } = useMutation({
        mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureAssignments"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { deactivateAssignment, isDeactivating };
}
